import { BackgroundTab, RestrictedModalItem } from "@/js/components/RegularClassroomUser/utils";

type ActiveTab = {
	id: string;
	active: boolean;
	url: string;
	favicon: string;
};

export type TabItem = RestrictedModalItem | BackgroundTab | ActiveTab;

/**
 * Extracts the URL from a tab item, handling different item types.
 * @param item - A RestrictedModalItem, BackgroundTab, or ActiveTab
 * @returns The URL string, or empty string if not found
 */
export function getTabUrl(item: TabItem): string {
	const isRestrictedOrBackground = "tabUrl" in item;
	return isRestrictedOrBackground ? item.tabUrl : (item as ActiveTab).url || "";
}

/**
 * Extracts the favicon URL from a tab item, handling different item types.
 * @param item - A RestrictedModalItem, BackgroundTab, or ActiveTab
 * @returns The favicon URL string, or empty string if not found
 */
export function getFaviconUrl(item: TabItem): string {
	return "favIcon" in item ? item.favIcon || "" : (item as ActiveTab).favicon || "";
}

/**
 * Checks if a URL is an internal browser tab (chrome:// or edge://).
 * @param url - The URL to check
 * @returns True if the URL is an internal browser tab, false otherwise
 */
export function isInternalBrowserTab(url: string): boolean {
	if (!url) return false;
	return url.startsWith("chrome://") || url.startsWith("edge://");
}
